import { IPreferences } from "./../types/interfaces";

export const preferenceDefaults: IPreferences.Preferences = {
    preferences: { pages: [] },
};

